// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Näytä salasana',
    hide: 'Piilota salasana',
    copy: 'Kopioi',
    copied: 'Kopioitu',
    once: 'Näytetään vain nyt. Kopioi se ja säilytä turvallisessa paikassa.',
  },
  loading: 'Ladataan muutosta…',
  load_failed: 'En voinut ladata tätä muutosta.',
  load_retry: 'Yritä uudelleen',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Tämä muutos näkyy tässä, kun Amigo on taas käytettävissä. Mitään ei ole muutettu.',
    assistant: 'Tämä muutos näkyy tässä, kun avustaja on taas käytettävissä. Mitään ei ole muutettu.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Tämä oli jo hyväksytty, joten mitään ei tarvinnut tehdä enää.',
  action_failed: 'Se ei mennyt läpi, joten mikään ei muuttunut. Yritä hetken kuluttua uudelleen.',
  removed: 'Poistettu',
  retry: 'Yritä uudelleen',
  retry_one: 'Yritä uudelleen: {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Hyväksytty.',
    retried: 'Yritetty uudelleen.',
    rejected: 'Hylätty.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Ohitettu kortissa.',
  },
  done: {
    summary_one: 'Valmis. {{count}} muutos otettu käyttöön.',
    summary_other: 'Valmis. {{count}} muutosta otettu käyttöön.',
    skipped_one: '{{count}} ohitettu, mikään ei muuttunut sen osalta.',
    skipped_other: '{{count}} ohitettu, mikään ei muuttunut niiden osalta.',
  },
  partial: {
    summary_one: '{{applied}} / {{approved}} muutosta otettu käyttöön. {{count}} ei onnistunut.',
    summary_other: '{{applied}} / {{approved}} muutosta otettu käyttöön. {{count}} ei onnistunut.',
    detail_one: '{{applied}} on tallennettu. Alla oleviin {{count}} ei tullut muutoksia.',
    detail_other: '{{applied}} on tallennettu. Alla oleviin {{count}} ei tullut muutoksia.',
  },
  stale: {
    summary: '{{applied}} / {{approved}} muutosta otettu käyttöön.',
    detail_one: 'Joku muu muutti {{count}} muutoksen välissä.',
    detail_other: 'Joku muu muutti {{count}} muutosta välissä.',
    reason:
      '{{name}} muutti arvoksi {{value}} kello {{time}}, ennen kuin hyväksyit, joten jätin sen ennalleen. Tässä se uudelleen uudesta arvosta:',
    decided_done:
      '{{name}} muutti sen arvoon {{value}} klo {{time}} ennen hyväksyntääsi, joten jätin sen ennalleen. Sen uusi ehdotus hyväksyttiin omalla kortillaan.',
    decided_rejected:
      '{{name}} muutti sen arvoon {{value}} klo {{time}} ennen hyväksyntääsi, joten jätin sen ennalleen. Sen uusi ehdotus hylättiin.',
    decided_replaced:
      '{{name}} muutti sen arvoon {{value}} klo {{time}} ennen hyväksyntääsi, joten jätin sen ennalleen. Sen uusi ehdotus korvattiin uudemmalla kortilla.',
    decided_expired:
      '{{name}} muutti sen arvoon {{value}} klo {{time}} ennen hyväksyntääsi, joten jätin sen ennalleen. Sen uusi ehdotus vanheni.',
  },
  undo_partly_one: '{{count}} näistä ei voi kumota.',
  undo_partly_other: '{{count}} näistä ei voi kumota.',
  undone: {
    summary_one: 'Kumottu. {{count}} muutos on palautettu ennalleen.',
    summary_other: 'Kumottu. {{count}} muutosta on palautettu ennalleen.',
    detail: 'Kumoaminen kirjataan myös Amigon lokiin ja kohtaan Menu → Muokkaushistoria.',
    partly_summary: 'Osittain kumottu. {{undone}}/{{count}} muutosta on palautettu ennalleen.',
    partly_changed_one: '{{count}} muutosta on muuttanut joku muu sen jälkeen, joten se pysyy ennallaan.',
    partly_changed_other: '{{count}} muutosta on muuttanut joku muu sen jälkeen, joten ne pysyvät ennallaan.',
    partly_kept_one: '{{count}} oli jo palautettu aiempaan tilaan.',
    partly_kept_other: '{{count}} oli jo palautettu aiempaan tilaan.',
    partly_cannot_one: '{{count}} ei voi perua, kuten poistoa, joten se pysyy ennallaan.',
    partly_cannot_other: '{{count}} ei voi perua, kuten poistoa, joten ne pysyvät ennallaan.',
    partly_left_one: '{{count}} pysyy ennallaan.',
    partly_left_other: '{{count}} pysyvät ennallaan.',
  },
  summary: {
    group_one: '{{count}} annos: {{reason}}',
    group_other: '{{count}} annosta: {{reason}}',
    group_names_more_one: '{{names}} ja {{count}} muuta',
    group_names_more_other: '{{names}} ja {{count}} muuta',
    average: '{{amount}} annosta kohden keskimäärin',
    needs_look: 'Vaatii tarkistuksen',
    nothing_else: 'Mikään muu ei muutu',
  },
  labels: {
    waiting: 'Odottaa',
    skip: 'Ohita',
    unskip: 'Peru ohitus',
    approve_all: 'Hyväksy kaikki',
    approve_one: 'Hyväksy {{count}}',
    approve_other: 'Hyväksy {{count}}',
    approve_all_count_one: 'Hyväksy kaikki {{count}}',
    approve_all_count_other: 'Hyväksy kaikki {{count}}',
    approve_row: 'Hyväksy',
    reject: 'Hylkää',
    reject_confirm: 'Hylkää',
    back: 'Takaisin',
    why: {
      amigo: 'Miksi ei? (valinnainen, Amigo lukee tämän)',
      assistant: 'Miksi ei? (valinnainen, avustaja lukee tämän)',
    },
    hint: 'Tai vastaa alla muuttaaksesi jotain.',
    show_all_one: 'Näytä kaikki {{count}} muutosta',
    show_all_other: 'Näytä kaikki {{count}} muutosta',
    show_less: 'Näytä vähemmän',
    applying_one: 'Otetaan käyttöön {{count}} muutos…',
    applying_other: 'Otetaan käyttöön {{count}} muutosta…',
    high_impact: 'Suuri vaikutus',
    done: 'Valmis',
    running: 'Käynnissä',
    show_changes: 'Näytä muutokset',
    hide_changes: 'Piilota muutokset',
    rows: {
      skipped: 'Ohitettu',
      applied: 'Otettu käyttöön',
      failed: 'Ei otettu käyttöön',
      changed: 'Muuttunut välillä',
      kept: 'Jätetty ennalleen',
    },
    history: {
      amigo: 'Avaa Amigon lokissa',
      assistant: 'Avaa avustajan lokissa',
    },
    undo: 'Kumoa',
    to: 'muotoon',
    from: 'muodosta',
    rejected: 'Hylätty',
    replaced: 'Korvattu',
    expired: 'Vanhentunut',
  },
};
